import { applyMiddleware, combineReducers, createStore } from "redux";
import createSagaMiddleware from "redux-saga";

import initialState from "./initialState";
import auth from "../modules/login/state/LoginReducer";
import admin from "../modules/admin/state/adminReducer";
import rad from "../modules/rad/state/radReducer";
import exam from "../modules/exam/state/examReducer";
import common from "../modules/common/state/commonReducer";
import site from "../modules/site/state/siteReducer";
import report from "../modules/reports/state/reportReducer";
import dailyReport from "../modules/reports/dailyReport/state/dailyReportReducer";
import marketVolumeShare from "../modules/reports/marketVolumeShare/state/marketVolumeShareReducer";
import coverageGapToolEncore from "../modules/reports/coverageGapToolEncore/state/coverageGapToolEncoreReducer";
import performanceDashboardCombined from "../modules/reports/performanceDashboardCombined/state/performanceDashboardCombinedReducer";
import dropdownMgmt from "../modules/admin/dropdownManagement/state/dropdownMgmtReducer";
import configuration from "../modules/admin/configuration/state/configurationReducer";
import matrixServiceRequest from "../modules/StrategicForecast/state/strategicforcecastreducer";
import rootSaga from "../services/watchSaga";
import demandTableReducer from '../modules/demandTable/state/DemandTableReducer';
import VolumeTrendReportReducer from '../modules/volumeTrendReport/state/volumeTrendReportReducer';
import capacityTableReducer from '../modules/capacityTable/state/CapacityTableReducer';
import CapsVsDemandReducer from '../modules/capacityVsdemnadTable/state/CapsVsDemandReducer';
import tenantManagementReducer from "../modules/tenantManagement/state/TenantManagementReducer";
import tenantHierarchyConfigurationReducer from "../modules/tenantHierarchyConfiguration/state/TenantHierarchyConfigurationReducer";
import liveAvailableShiftsReducer from "../modules/liveAvailableShifts/state/LiveAvailableShiftsReducer";
import forecastReducer from "../modules/demandForecast/forecasting/state/forecastReducer";
// import forecastReducer2 from "../modules/demandForecast2/forecasting/state/forecastReducer";
// import forecastingForecastReducer from "../modules/forecasting/forecast/state/ForecastingForecastReducer";
import timeZoneMasterReducer from "../modules/timeZoneMaster/state/TimeZoneMasterReducer";

// import { strategicdemandReducer } from "../modules/StrategicForecast/strategicdemandplanner/state/strategicdemandreducer";
// import { strategicCapacityReducer  } from "../modules/StrategicForecast/strategiccapacityplanner/state/strategicapacityreducer";

import strategicdemandReducer from "../modules/StrategicForecast/strategicdemandplanner/state/strategicdemandreducer";
import strategicCapacityReducer from "../modules/StrategicForecast/strategiccapacityplanner/state/strategicapacityreducer";
import strategicCapsVsDemandReducer from "../modules/StrategicForecast/strategicCapsVsDemPlanner/state/strategicCapsVsDemandReducer";
import scheduleViewer from "../modules/schedule/state/scheduleViewerReducer";
import shareLinks from "../modules/schedule/shareLinks/state/ShareLinksReducer";
import schedulingCalendar from "../modules/schedulingCalendar/state/schedulingCalendarReducer";
import providerRequest from "../modules/schedule/providerRequest/state/providerRequestReducer";
import changePassword from "../modules/changePassword/state/changePasswordReducer";

const rootReducer = combineReducers({
    auth,
    admin,
    common,
    dropdownMgmt,
    configuration,
    rad,
    exam,
    site,
    report,
    dailyReport,
    marketVolumeShare,
    coverageGapToolEncore,
    performanceDashboardCombined,
    matrixServiceRequest,
    demandTableReducer,
    VolumeTrendReportReducer,
    capacityTableReducer,
    CapsVsDemandReducer,
    strategicdemandReducer,
    strategicCapacityReducer,
    tenantManagementReducer,
    tenantHierarchyConfigurationReducer,
    timeZoneMasterReducer,
    liveAvailableShiftsReducer,
    forecastReducer,
    strategicCapsVsDemandReducer,
    scheduleViewer,
    shareLinks,
    schedulingCalendar,
    providerRequest,
    changePassword,
    // forecastReducer2,
    // forecastingForecastReducer,
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(rootReducer, initialState, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export default store;